import { createAnatomy as d } from "../../anatomy/dist/index.mjs";
import { createScope as g } from "../../dom-query/dist/index.mjs";
import { createProps as l } from "../../types/dist/index.mjs";
var n = d("select").parts(
  "label",
  "positioner",
  "trigger",
  "indicator",
  "clearTrigger",
  "item",
  "itemText",
  "itemIndicator",
  "itemGroup",
  "itemGroupLabel",
  "list",
  "content",
  "root",
  "control"
);
n.build();
var o = g({
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `select:${e.id}`;
  },
  getContentId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.content) ?? `select:${e.id}:content`;
  },
  getTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.trigger) ?? `select:${e.id}:trigger`;
  },
  getClearTriggerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.clearTrigger) ?? `select:${e.id}:clear-trigger`;
  },
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `select:${e.id}:label`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `select:${e.id}:control`;
  },
  getItemId: (e, t) => {
    var i, r;
    return ((r = (i = e.ids) == null ? void 0 : i.item) == null ? void 0 : r.call(i, t)) ?? `select:${e.id}:option:${t}`;
  },
  getHiddenSelectId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.hiddenSelect) ?? `select:${e.id}:select`;
  },
  getPositionerId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.positioner) ?? `select:${e.id}:positioner`;
  },
  getItemGroupId: (e, t) => {
    var i, r;
    return ((r = (i = e.ids) == null ? void 0 : i.itemGroup) == null ? void 0 : r.call(i, t)) ?? `select:${e.id}:optgroup:${t}`;
  },
  getItemGroupLabelId: (e, t) => {
    var i, r;
    return ((r = (i = e.ids) == null ? void 0 : i.itemGroupLabel) == null ? void 0 : r.call(i, t)) ?? `select:${e.id}:optgroup-label:${t}`;
  },
  getHiddenSelectEl: (e) => o.getById(e, o.getHiddenSelectId(e)),
  getContentEl: (e) => o.getById(e, o.getContentId(e)),
  getControlEl: (e) => o.getById(e, o.getControlId(e)),
  getTriggerEl: (e) => o.getById(e, o.getTriggerId(e)),
  getClearTriggerEl: (e) => o.getById(e, o.getClearTriggerId(e)),
  getPositionerEl: (e) => o.getById(e, o.getPositionerId(e)),
  getHighlightedOptionEl(e) {
    return e.highlightedValue ? o.getById(e, o.getItemId(e, e.highlightedValue)) : null;
  }
});
l()([
  "closeOnSelect",
  "collection",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "highlightedValue",
  "id",
  "ids",
  "invalid",
  "loopFocus",
  "multiple",
  "name",
  "onFocusOutside",
  "onHighlightChange",
  "onInteractOutside",
  "onOpenChange",
  "onPointerDownOutside",
  "onValueChange",
  "open.controlled",
  "open",
  "composite",
  "positioning",
  "required",
  "readOnly",
  "scrollToIndexFn",
  "value"
]);
l()(["item", "persistFocus"]);
l()(["id"]);
l()(["htmlFor"]);
export {
  n as anatomy
};
